import { SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <div className="px-6 py-4">
      <SkeletonBlock className="h-5" />
      <div className="flex flex-col gap-3 px-4">
        <SkeletonBlock className="mt-7 mb-3 h-[18px] w-[200px]" />
        <div className="grid grid-cols-2 gap-4">
          <SkeletonBlock className="h-[52px]" />
          <SkeletonBlock className="h-[52px]" />
          <SkeletonBlock className="h-[52px]" />
          <SkeletonBlock className="h-[52px]" />
        </div>

        <SkeletonBlock className="mt-7 mb-3 h-[18px] w-[200px]" />
        <div className="grid grid-cols-2 gap-4">
          <SkeletonBlock className="h-[52px]" />
          <SkeletonBlock className="h-[52px]" />
          <SkeletonBlock className="h-[52px]" />
          <SkeletonBlock className="h-[52px]" />
        </div>
      </div>

      <SkeletonBlock className="mt-5 h-5" />
      <div className="flex flex-col gap-3 px-4">
        <SkeletonBlock className="mt-7 mb-3 h-[18px] w-[200px]" />
        <div className="grid grid-cols-2 gap-4">
          <SkeletonBlock className="h-[52px]" />
          <SkeletonBlock className="h-[52px]" />
        </div>
      </div>
    </div>
  )
}
